import * as stylex from "@stylexjs/stylex";
import React from "react";
import { typography } from "../../../materials/typography.stylex";
import { lineChartDefaultStyles as styles } from "./styles";
const YTick = React.memo(({ width, label, transform, labelPadding })=><g transform={transform}>
      <line {...stylex.props(styles.axisYLine)} x2={width} {...labelPadding && {
        strokeDasharray: `${labelPadding} 5 ${width}`
    }}/>
      <text {...stylex.props(typography.axis, styles.axisLabel)} dy="-3px">
        {label}
      </text>
    </g>);
export default YTick;
